'use client'

import { SLIDER_CLASS_NAME } from '@/constants'
import { ArticleSubcategory } from '@/types/api/article-category'
import cx from 'classnames'
import s from './subcategory-chip.module.css'
import Link from 'next/link'

type Props = {
  subcategory: ArticleSubcategory
  active?: boolean
  onClick?: () => void
}

export const SubcategoryChip = ({
  subcategory,
  active = false,
  onClick,
}: Props) => {
  return (
    <Link
      onClick={onClick}
      href={`/${subcategory.parent_slug}?subcategory=${subcategory.slug}`}
      scroll={false}
      className={cx(SLIDER_CLASS_NAME, s.sliderItem, {
        [s.active]: active,
      })}
    >
      {subcategory.name}
    </Link>
  )
}
